import { render, staticRenderFns } from "./SZPriceRate.vue?vue&type=template&id=bb5e7bc8"
import script from "./SZPriceRate.vue?vue&type=script&lang=js"
export * from "./SZPriceRate.vue?vue&type=script&lang=js"
import style0 from "./SZPriceRate.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports